"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Format price to 2 decimals and if integer return full integer.
 * Also, includes the $ prefix (eg. 3 => $3, 3.3124 => $3.31)
 *
 * @param {number} price
 * @returns {string}
 */
const formatPrice = (price, includeCurrency = false, lang = 'en') => {
    const formatted = Number(price).toFixed(2).split('.00')[0];
    const formattedValid = isNaN(Number(formatted)) ? price : formatted;
    const prefix = includeCurrency && lang === 'en' ? '$' : '';
    const postfix = includeCurrency && lang === 'fr' ? ' $' : '';
    return `${prefix}${formattedValid}${postfix}`;
};
exports.default = formatPrice;
//# sourceMappingURL=formatPrice.js.map